import {NamedAction, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalNamedActionExecuteNamed} from "./PortalNamedActionExecuteNamed";
import {PortalActionType} from "./PortalActionEvent";

export class PortalNamedAction extends NamedAction implements Parameter {
	public executeNamed?: PortalNamedActionExecuteNamed;
	public type?: PortalActionType;

	constructor(data: any) {
		super(data);

		this.executeNamed = PortalNamedActionExecuteNamed.fromJson(data?.executeNamed);
		this.type = FunctionHelper.exists(data?.type) ? data.type : PortalActionType.None;
	}

	public static getTypeDefault(): PortalActionType {
		return PortalActionType.None;
	}

	public static fromJson(data: any): PortalNamedAction {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalNamedAction(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'type': this.type
		};
	}

	public clone(): PortalNamedAction {
		return PortalNamedAction.fromJson(this.toJson());
	}
}